import {IWorkTypeActionCreator,IWorkTypeState,IWorkTypeActionTypes} from 'models/IWorkTypeState';

const initialState:IWorkTypeState[] = []

const reducer = (state = initialState, { type, payload }: IWorkTypeActionCreator) => {
    switch (type) {
      case IWorkTypeActionTypes.FETCH_WORK_TYPES_REQUEST:
        return {
          ...state,
          data:[],
        }
      case IWorkTypeActionTypes.FETCH_WORK_TYPES_SUCCESS:
        return {
          ...state,
          ...payload
        }
      default:
        return state;
    }
  };
  
  export default reducer;